import { isNonNullish } from '@epicuro-next/utilities';
import { Dictionary } from '@ngrx/entity';
import { Account } from 'graphql-api/gql-api-interfaces';

import { getAddressUniqueId } from '../get-address-unique-id/get-address-unique-id';

export function mapSelectedIdsToAccounts(
  selectedAccountIds: string[],
  selectedAddressesIds: string[],
  accountEntity: Dictionary<Account>,
): Account[] {
  return selectedAccountIds
    .map((accountId) => accountEntity[accountId])
    .filter(isNonNullish)
    .map((account) => {
      let shipToAddresses = account.shipToAddresses.map((address) => ({
        ...address,
        hasDeliveryItems: selectedAddressesIds.includes(
          getAddressUniqueId(address),
        ),
      }));

      if (
        !shipToAddresses.some((shipToAddress) => shipToAddress.hasDeliveryItems)
      ) {
        shipToAddresses = shipToAddresses.map((shipToAddress) => ({
          ...shipToAddress,
          hasDeliveryItems: true,
        }));
      }
      return {
        ...account,
        shipToAddresses,
      };
    });
}
